import type { SupportedLocale } from '@erp/shared';

export const documentNumberTranslations = {
  de: {
    label: 'Belegnummer',
    hint: 'Leer lassen für automatische Vergabe. Eine eigene Nummer muss innerhalb dieser Belegart eindeutig sein.',
    savedHint: 'Die Nummer ist nach dem Anlegen fest vergeben.',
    automatic: 'Wird beim Speichern vergeben',
    taken:
      'Diese Belegnummer ist für diese Belegart bereits vergeben. Bitte eine andere Nummer eingeben oder das Feld für die automatische Vergabe leeren.',
    invalid: 'Die Belegnummer darf keine Steuerzeichen oder unsichtbaren Formatzeichen enthalten.',
    blocked: 'Während der Datenbereinigung können keine Belegnummern vergeben werden.',
  },
  en: {
    label: 'Document number',
    hint: 'Leave blank for automatic numbering. A custom number must be unique within this document type.',
    savedHint: 'The number is fixed after creation.',
    automatic: 'Assigned on saving',
    taken:
      'This number is already used for this document type. Enter another number or clear the field for automatic numbering.',
    invalid:
      'The document number must not contain control characters or invisible formatting characters.',
    blocked: 'Document numbers cannot be assigned during data cleanup.',
  },
  fr: {
    label: 'Numéro du document',
    hint: 'Laissez vide pour une attribution automatique. Un numéro personnel doit être unique pour ce type de document.',
    savedHint: 'Le numéro est définitif après la création.',
    automatic: 'Attribué à l’enregistrement',
    taken:
      'Ce numéro est déjà utilisé pour ce type de document. Saisissez un autre numéro ou videz le champ pour une attribution automatique.',
    invalid:
      'Le numéro ne peut contenir ni caractères de contrôle ni caractères de formatage invisibles.',
    blocked: 'L’attribution des numéros est bloquée pendant le nettoyage des données.',
  },
  es: {
    label: 'Número del documento',
    hint: 'Deje vacío para numeración automática. El número propio debe ser único para este tipo de documento.',
    savedHint: 'El número queda fijo tras la creación.',
    automatic: 'Se asigna al guardar',
    taken:
      'Este número ya se utiliza para este tipo de documento. Introduzca otro o vacíe el campo para numeración automática.',
    invalid:
      'El número no puede contener caracteres de control ni caracteres de formato invisibles.',
    blocked: 'No se pueden asignar números durante la limpieza de datos.',
  },
  tr: {
    label: 'Belge numarası',
    hint: 'Otomatik numara için boş bırakın. Özel numara bu belge türünde benzersiz olmalıdır.',
    savedHint: 'Oluşturulduktan sonra numara sabittir.',
    automatic: 'Kaydederken atanır',
    taken:
      'Bu numara bu belge türünde kullanılıyor. Başka numara girin veya otomatik numara için alanı boşaltın.',
    invalid: 'Belge numarası kontrol veya görünmez biçimlendirme karakterleri içeremez.',
    blocked: 'Veri temizliği sırasında belge numarası atanamaz.',
  },
} satisfies Record<SupportedLocale, Record<string, string>>;
